import { type ReactNode } from "react";

import { Box, Divider, MenuItem } from "@mui/material";

import { primaryAccentColor } from "@/src/theme/helpers";

interface HamburgerMenuItemProps {
  id: string;
  onClick: () => void;
  label: ReactNode;
  attentionCount?: number;
  divider?: boolean;
}

const HamburgerMenuItem = (props: HamburgerMenuItemProps) => {
  const { id, onClick, label, attentionCount, divider } = props;

  return (
    <>
      <MenuItem id={id} onClick={onClick}>
        {label}
        {attentionCount && attentionCount > 0 && (
          <Box
            sx={(muiTheme) => ({
              ml: 0.5,
              color: primaryAccentColor(muiTheme),
              fontWeight: muiTheme.typography.fontWeightMedium
            })}
          >
            ({attentionCount})
          </Box>
        )}
      </MenuItem>
      {divider && <Divider />}
    </>
  );
};

export default HamburgerMenuItem;
